import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import { CentralAuthenticationService } from '../services/central-authentication.service';

@Injectable({
  providedIn: 'root'
})
export class CentralForwardGuard  {
  constructor(private centralAuth: CentralAuthenticationService,
              private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const result = new Subject<boolean>();
    this.centralAuth.isAuthenticated().subscribe(
      res => {
        if (res) {
          this.router.navigateByUrl('/launch');
          result.next(false);
          result.complete();
        } else {
          result.next(true);
          result.complete();
        }
      }, error => {
        result.next(true);
        result.complete();
      }
    );
    return result.asObservable();
  }
}
